import { StyleSheet } from 'aphrodite/no-important';

import colors from '../../identity/colors';
import typeContent from '../../identity/type';
import spacing from '../../identity/spacing';
import screens from '../../identity/screenSizes';

export default StyleSheet.create({

  container: {
    padding: spacing.DESKTOP_T_R_L,
    paddingBottom: '120px',
    display: 'flex',
    alignItems: 'center',
    backgroundColor: colors.WHITE,

    [screens.TABLET]: { padding: spacing.MOBILE_V_H },
    [screens.DESKTOP_HD]: { padding: '132px 66px' },
    [screens.MOBILE]: { padding: '108px 16px' },
  },

  allText: {
    marginLeft: '32%',


    [screens.TABLET]: { margin: '0' },
  },

  header: {
    ...typeContent.H1,
    color: colors.GREY_NO_40,
    margin: '0 0 40px 0',

    [screens.MOBILE]: { fontSize: '30px'},

  },

  content: {
    color: colors.GREY_NO_50,
    margin: '0 0 60px 0',
    ...spacing.M_B_L,
    ...typeContent.H3,
    lineHeight: typeContent.H1.lineHeight,
    maxWidth: '864px',

    [screens.MOBILE]: { fontSize: '21px' },

  },

  tagCategories: {
    ...typeContent.SMALL,
    fontWeight: 500,
    color: colors.GREY_NO_60,
    margin: 0,

  },

});



// WEBPACK FOOTER //
// ./src/components/ProjectIntro/styles.js